import {Storage} from '@ionic/storage'
import axios from "axios";
import router from "../../router";

const storage = new Storage()

const state = {
    messages: {},
    message: null,
    current_route: null,
    closed_messages: [],
    hidden_messages: [],

}
const mutations = {
    SET_MESSAGES(state, value) {
        state.messages = value
    },
    SET_MESSAGE(state, value) {
        state.message = value
    },
    SET_CLOSED_MESSAGES(state, value) {
        state.closed_messages = value
    },
    SET_HIDDEN_MESSAGES(state, value) {
        state.hidden_messages = value
    },
    SET_CURRENT_ROUTE(state, value) {
        state.current_route = value
    }
}
const actions = {
    async setMessages({commit, state, dispatch}, value) {
/*
        let messages = {}
        value.forEach(message => {
            let route = message.route
            if (!route || route.length < 1) route = '/'
            if (!messages[route]) messages[route] = []
            messages[route].push(message)
        })
        commit('SET_MESSAGES', messages)
 */
        let hidden_messages = []
        await storage.get('hidden_messages').then((val) => {
            hidden_messages = val || []
        })
        commit('SET_HIDDEN_MESSAGES', hidden_messages)

        commit('SET_MESSAGES', value)

        setTimeout(() => dispatch('loadMessages'), 1000 * 60 * 10)
    },
    setMessage({commit}, value) {
        commit('SET_MESSAGE', value)
    },
    async dismissMessage({state, commit, getters}, hide) {
        //let closed_messages = state.closed_messages
        let message_id = getters['message'].id
        state.closed_messages.push(message_id)
        if (hide) {
            let hidden_messages = []
            await storage.get('hidden_messages').then((val) => {
                hidden_messages = val || []
            })
            hidden_messages.push(message_id)
            storage.set('hidden_messages', hidden_messages)
            commit('SET_HIDDEN_MESSAGES', hidden_messages)
        }
        //commit('SET_CLOSED_MESSAGES', closed_messages)

        //commit('SET_MESSAGE', null)
    },
    setCurrentRoute ({commit}, value) {
        commit('SET_CURRENT_ROUTE', value)
        commit('SET_CLOSED_MESSAGES', [])
    },
    loadMessages ({dispatch, rootState}) {
        axios.post(rootState.settings.baseUrl + 'load-messages', {challenge_id: rootState.challenge.challenge.id},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then( response => {
            // commit('global/SET_SYNCING', null, { root: true })
            dispatch('setMessages', response.data)
        }).catch(error => {
            console.error(error)
        })
    }

}
const getters = {
    message: (state, getters) => {
        return getters['messages'][0]
    },
    messages: (state) => {
        if(!state.messages || !state.messages.filter) return []
        let messages = state.messages.filter(message => {
            if(message.route.slice(-2) === '/*') message.route = message.route.slice(0, -2)
            return state.closed_messages.indexOf(message.id) < 0 && state.hidden_messages.indexOf(message.id) < 0 && (!message.route || state.current_route.indexOf(message.route) >= 0)
        })
        return messages
    },
    route_messages: (state) => (route) => {
        if(!state.messages.filter) return []
        let messages = state.messages.filter(message => {
            if(message.route.slice(-2) === '/*') message.route = message.route.slice(-2)
            return (route.indexOf(message.route) >= 0 ) || (!route && !message.route)
        })

        return messages
    }

}
export default {
    namespaced: true, state, mutations, actions, getters
}
